"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserBackend = void 0;

var _tslib = require("tslib");

var _core = require("@sentry/core");

var _types = require("@sentry/types");

var _utils = require("@sentry/utils");

var _eventbuilder = require("./eventbuilder");

var _transports = require("./transports");

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = exports.BrowserBackend = function (_super) {
  (0, _tslib.__extends)(BrowserBackend, _super);

  function BrowserBackend() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype.eventFromException = function (exception, hint) {
    return (0, _eventbuilder.eventFromException)(exception, hint, this._options.attachStacktrace);
  };
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
    if (level === void 0) {
      level = _types.Severity.Info;
    }

    return (0, _eventbuilder.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
  };
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype._setupTransport = function () {
    if (!this._options.dsn) {
      // We return the noop transport here in case there is no Dsn.
      return _super.prototype._setupTransport.call(this);
    }

    var transportOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._options.transportOptions), {
      dsn: this._options.dsn,
      tunnel: this._options.tunnel,
      sendClientReports: this._options.sendClientReports,
      _metadata: this._options._metadata
    });
    var api = (0, _core.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
    var url = (0, _core.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);

    if (this._options.transport) {
      return new this._options.transport(transportOptions);
    }

    if ((0, _utils.supportsFetch)()) {
      var requestOptions = (0, _tslib.__assign)({}, transportOptions.fetchParameters);
      this._newTransport = (0, _transports.makeNewFetchTransport)({
        requestOptions: requestOptions,
        url: url
      });
      return new _transports.FetchTransport(transportOptions);
    }

    this._newTransport = (0, _transports.makeNewXHRTransport)({
      url: url,
      headers: transportOptions.headers
    });
    return new _transports.XHRTransport(transportOptions);
  };

  return BrowserBackend;
}(_core.BaseBackend);